<script>
import TaxonList from '../components/taxon/TaxonList.vue';
import FilterList from '../components/filter/FilterList.vue';
import TaxonHeader from '../components/taxon/TaxonHeader.vue';
import ProductList from '../components/product/ProductList.vue';
import ComparedProductListBar from '../components/product/compare/ComparedProductListBar.vue';

export default {
  name: 'SearchView',
  components: {
    TaxonList,
    FilterList,
    TaxonHeader,
    ProductList,
    ComparedProductListBar,
  },
};
</script>

<template>
  <div class="w-full flex flex-wrap">
    <div class="flex flex-col w-full md:w-1/6 ">
      <TaxonList />
      <FilterList />
    </div>

    <div class="w-full md:w-5/6 mt-6 md:mt-0">
      <div class="md:pl-6 md:mt-0 text-gray-900 bg-white">
        <TaxonHeader />
        <ProductList />
      </div>
    </div>

    <ComparedProductListBar />
  </div>
</template>
